//@ts-nocheck - window.twq events are not typed
const twitterPixelEvents = {
    signup: () => window.twq?.('event', 'tw-odwtp-oe6d5'),
    subscribe: () => window.twq?.('event', 'tw-odwtp-oe7xm'),
    addToCart: () => window.twq?.('event', 'tw-odwtp-oe7xk'),
};

export default twitterPixelEvents;
